import { gql } from "@apollo/client";
import axios from "axios";
import { destroyCredentials } from "../Actions/userSessionActions";
import store from "../store";

export function checkCredentials(response) {
    if ("status" in response?.data && response?.data.status === 401) {
        window.location.reload();
    }
}

export function logOut(user_triggered = false) {
    return new Promise((resolve, reject)=>{
        if (store) {
            user_triggered ? 
                showStatusMsg('Logging out...', 'success')
                : showStatusMsg('Your session has expired. Please login again to continue.');
            axios.get('/ajax/logout&redirect')
            .finally(()=>{
                store.dispatch(destroyCredentials());
                localStorage.clear();
                window.location.reload();
                resolve('Logged out');
            });
        } else{{/** no userSession generated */}
            // console.log('no store generated', store);
            localStorage.clear();
            if (user_triggered) window.location.reload();
            resolve('Logged out');
        }
    })
}

export async function refreshToken(client) {
    const REFRESH = gql`
        query RefreshToken($sub: ID!, $refreshToken: String!) {
            refreshAccessToken(input: { sub: $sub, refreshToken: $refreshToken }) {
                accessToken
                refreshToken
                expiresIn
                userInfo {
                    sub
                    issuedBy
                    name
                }
            }
        }
    `;

    return new Promise((resolve, reject) => {
        client.query({query: REFRESH, variables: {
            sub: localStorage.getItem('sub'),
            refreshToken: localStorage.getItem('refresh_token'),
        }}).then((data)=> {
            // console.log('tried to refresh token', data);
            if (data.errors) {
                logOut();
                reject(errors);
            } else {
                let new_data = data.data.refreshAccessToken;
                localStorage.setItem('access_token', new_data.accessToken);
                localStorage.setItem('refresh_token', new_data.refreshToken);
                resolve(new_data.accessToken);
            }
        }).catch((err) => {
            // console.log('error refreshing token', err);
            logOut();
            reject(err);
        })
    })
}